
export const typeRole = [
    { id: '5b167d13e48150001143b26e', name: 'Super Admin' },
    { id: '5b167d28e48150001143b2be', name: 'Admin' },
    { id: '5b1c05b4e65e1838250ffc38', name: 'User' },
]

export const SUPERADMIN = 'superadmin';
export const ADMIN = 'admin';


// WEBPACK FOOTER //
// ./src/constant/TypeRole.js